import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, MessageSquareQuote } from "lucide-react";
import { useLocale } from "../i18n/LocaleContext";
import { GOOGLE_PROFILE_URL, GOOGLE_REVIEW_URL } from "../config";
import { GoogleIcon } from "./icons";

export function GoogleFloat() {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div ref={ref} className="fixed bottom-6 right-6 z-40">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.97 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            data-testid="google-menu"
            className="absolute bottom-full right-0 mb-4 w-64 border border-imperium-champagne/40 bg-imperium-white py-2 shadow-[0_24px_60px_-24px_rgba(48,37,31,0.35)]"
          >
            <a
              href={GOOGLE_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-rate-link"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-5 py-3.5 text-sm text-imperium-black/85 transition-colors hover:bg-imperium-offwhite"
            >
              <Star className="h-4 w-4 text-imperium-gold" />
              {t("google.rate")}
            </a>
            <div className="mx-5 h-px bg-imperium-cream" aria-hidden="true" />
            <a
              href={GOOGLE_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-link"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-5 py-3.5 text-sm text-imperium-black/85 transition-colors hover:bg-imperium-offwhite"
            >
              <MessageSquareQuote className="h-4 w-4 text-imperium-gold" />
              {t("google.reviews")}
            </a>
          </motion.div>
        )}
      </AnimatePresence>
      <button
        type="button"
        data-testid="google-float-button"
        aria-label={t("google.label")}
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="flex h-14 w-14 items-center justify-center rounded-full border border-imperium-champagne/50 bg-white p-3.5 shadow-[0_16px_40px_-12px_rgba(29,26,24,0.35)] transition-all duration-300 hover:scale-105"
      >
        <GoogleIcon className="h-7 w-7" />
      </button>
    </div>
  );
}
